import { useQuery } from "@tanstack/react-query";
import { useRuntime } from "../runtime/RuntimeContext";
import type { PresentationConfig } from "../../core";

const FALLBACK: PresentationConfig = { title: "EDE Workspace", favicon_url: "/favicon" };

/**
 * Branding bundle (title + favicon URL) resolved on the backend from
 * `ir.config`. Fetched once per SPA boot, cached for the session (staleTime
 * Infinity). Pre-login accessible. Consumers read the `.data` directly OR
 * fall back to the literal defaults when the query is still pending.
 */
export function usePresentationConfig() {
    const runtime = useRuntime();
    return useQuery({
        queryKey: ["presentation-config"],
        queryFn: () => runtime.services.bootstrap.presentation(),
        staleTime: Infinity,
        placeholderData: FALLBACK,
    });
}
